"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const hooks_1 = require("../../hooks");
const index_1 = require("../index");
function MakeAdminButton({ groupId, userId }) {
    const sharingService = (0, hooks_1.useSharing)();
    const onGrantAdminPermissions = () => {
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.grantAdmin({
            group: groupId,
            to_user_id: userId,
        });
    };
    return ((0, jsx_runtime_1.jsx)(index_1.StyledMemberButton, { onClick: onGrantAdminPermissions, "data-e2e": 'MakeAdminButton_StyledMemberButton', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.makeAdmin) }));
}
exports.default = MakeAdminButton;
